import { AbfSdkMiddleware, AbfSdkReducers } from "@bridgesplit/abf-react";
import { InternalSdkReducers } from "@bridgesplit/react";
import { PayloadAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";

enableMapSet();

const appReducer = combineReducers({
    ...InternalSdkReducers,
    ...AbfSdkReducers
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: RootState | undefined, action: PayloadAction) => {
    if (action.type === "RESET_APP") {
        return appReducer(undefined, { type: undefined });
    }
    return appReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
    // don't use sentry enhancer to prevent leak of data in redux
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(...AbfSdkMiddleware)
});

export default store;
